export default [
  {
    path: '/findPwdValidCode',
    name: 'FindPwdValidCode',
    component: () => import('@/views/findPwd/findPwdValidCode.vue'),
  },
  {
    path: '/findPwdValidUser',
    name: 'FindPwdValidUser',
    component: () => import('@/views/findPwd/findPwdValidUser.vue'),
  },
  {
    path: '/findPwdValidCard',
    name: 'FindPwdValidCard',
    component: () => import('@/views/findPwd/findPwdValidCard.vue'),
  },
  {
    path: '/confirmPwd',
    name: 'ConfirmPwd',
    component: () => import('@/views/findPwd/confirmPwd.vue'),
  },
  {
    path: '/setPwd',
    name: 'SetPwd',
    component: () => import('@/views/findPwd/setPwd.vue'),
  },
]
